<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #ZellePagos
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
          v-card-title(style='padding: 8px !important;').justify-center
            img(src='../assets/logo.png', style='height: auto;width: 140px;')
        v-card(color='', style="border-radius:5px;background-color: black")
          v-card-title(style="padding: 7px;").justify-center
            span.white--text Pagos Zelle

    //- Modal detalle del pago
    v-dialog(v-model='dialogDetalle', max-width='600px')
      v-container(style='background-color:white !important;max-width:600px;')
        v-card-title.justify-center
          span.headline Detalle del Pago
        v-divider
        div(style='padding: 20px;' v-if='pagoSeleccionado')
          v-layout(row wrap)
            v-flex(xs6)
              p
                b Nombre:
                |  {{ pagoSeleccionado.nombre }}
            v-flex(xs6)
              p
                b Monto:
                |  ${{ pagoSeleccionado.monto ? pagoSeleccionado.monto.toFixed(2) : '0.00' }}
            v-flex(xs6)
              p
                b Referencia:
                |  {{ pagoSeleccionado.referencia || '-' }}
            v-flex(xs6)
              p
                b Fecha:
                |  {{ transform(pagoSeleccionado.fecha) }}
            v-flex(xs6)
              p
                b Estatus:
                v-chip(:color='colorEstatus(pagoSeleccionado.estatus)' text-color='white' small style='margin-left:8px;')
                  | {{ pagoSeleccionado.estatus }}
            v-flex(xs6 v-if='pagoSeleccionado.nombre_cliente')
              p
                b Cliente:
                |  {{ pagoSeleccionado.nombre_cliente }}
            v-flex(xs6 v-if='pagoSeleccionado.ven_des')
              p
                b Vendedor:
                |  {{ pagoSeleccionado.ven_des }}
            v-flex(xs12 v-if='pagoSeleccionado.comprobante')
              p
                b Comprobante:
              a(:href='pagoSeleccionado.comprobante' target='_blank')
                img(:src='pagoSeleccionado.comprobante' style='max-width:100%;max-height:300px;border-radius:8px;object-fit:contain;')
          v-divider(style='margin-top:16px;')
          v-layout(wrap justify-end style='margin-top:12px;gap:8px;')
            v-btn(
              v-if="pagoSeleccionado.estatus === 'pendiente'"
              color='blue'
              dark
              :loading='loadingAsignar'
              @click='abrirAsignacion(pagoSeleccionado)'
            ) Asignar Cliente
            v-btn(
              v-if="pagoSeleccionado.estatus === 'Asignado'"
              color='green'
              dark
              :loading='loadingProcesar'
              @click='procesarPago(pagoSeleccionado._id)'
            ) Procesar
            v-btn(
              v-if="['Asignado','Procesado'].includes(pagoSeleccionado.estatus)"
              color='orange'
              dark
              :loading='loadingReset'
              @click='resetPago(pagoSeleccionado._id)'
            ) Volver a Pendiente
            v-btn(
              v-if="['pendiente','Asignado'].includes(pagoSeleccionado.estatus)"
              color='red'
              dark
              :loading='loadingRechazar'
              @click='rechazarPago(pagoSeleccionado._id)'
            ) Rechazar
            v-btn(@click='dialogDetalle = false') Cerrar

    //- Modal asignación manual
    v-dialog(v-model='dialogAsignar', max-width='500px' persistent)
      v-container(style='background-color:white !important;max-width:500px;')
        v-card-title.justify-center
          span.headline Asignar Cliente
        v-divider
        div(style='padding:20px;')
          v-text-field(
            v-model='busquedaCliente'
            label='Buscar por nombre o código'
            clearable
            @input='buscarClientes'
            prepend-inner-icon='search'
            :loading='loadingClientes'
            autocomplete='off'
          )
          div(v-if='clientesBusqueda.length > 0' style='max-height:250px;overflow-y:auto;border:1px solid #e0e0e0;border-radius:6px;margin-top:4px;')
            div(
              v-for='cli in clientesBusqueda'
              :key='cli.co_cli'
              @click='seleccionarCliente(cli)'
              style='padding:10px 14px;cursor:pointer;border-bottom:1px solid #f5f5f5;'
              :style="clienteSeleccionado && clienteSeleccionado.co_cli === cli.co_cli ? 'background:#e3f2fd;' : ''"
            )
              div(style='font-weight:500;font-size:13px;') {{ cli.cli_des.trim() }}
              div(style='font-size:11px;color:#757575;') {{ cli.co_cli.trim() }}
          div(v-if='busquedaCliente && busquedaCliente.length >= 2 && clientesBusqueda.length === 0 && !loadingClientes' style='padding:10px;color:#999;font-size:13px;text-align:center;') No se encontraron clientes
          div(v-if='clienteSeleccionado' style='margin-top:12px;padding:10px 14px;background:#e8f5e9;border-radius:6px;border-left:4px solid #4caf50;')
            div(style='font-size:11px;color:#388e3c;font-weight:600;margin-bottom:2px;') CLIENTE SELECCIONADO
            div(style='font-weight:600;font-size:13px;') {{ clienteSeleccionado.cli_des.trim() }}
            div(style='font-size:12px;color:#555;') Código: {{ clienteSeleccionado.co_cli.trim() }}
          v-text-field(
            v-model='referenciaManual'
            label='Referencia (opcional)'
            style='margin-top:12px;'
          )
          div(style='margin-top:12px;')
            div(style='font-size:12px;color:#555;margin-bottom:6px;') Comprobante (opcional)
            div(
              @click='$refs.inputImagen.click()'
              style='border:2px dashed #e0e0e0;border-radius:8px;padding:12px;cursor:pointer;text-align:center;background:#fafafa;'
              :style="imagenManual ? 'border-color:#4caf50;' : ''"
            )
              div(v-if='!imagenManual')
                v-icon(color='grey' size='36') cloud_upload
                div(style='font-size:13px;color:#9e9e9e;margin-top:4px;') Haz clic para seleccionar imagen
              div(v-else)
                img(:src='imagenManualPreview' style='max-width:100%;max-height:180px;border-radius:6px;object-fit:contain;')
                div(style='font-size:12px;color:#4caf50;margin-top:4px;') {{ imagenManual.name }}
            input(ref='inputImagen' type='file' accept='image/*' style='display:none;' @change='onImagenSeleccionada')
            v-btn(v-if='imagenManual' small text color='red' @click='imagenManual=null;imagenManualPreview=null;' style='margin-top:4px;') Quitar imagen
        v-divider
        v-layout(justify-end style='padding:12px;gap:8px;')
          v-btn(@click='dialogAsignar = false') Cancelar
          v-btn(
            color='blue'
            dark
            :loading='loadingAsignar'
            :disabled='!clienteSeleccionado'
            @click='confirmarAsignacion'
          ) Confirmar Asignación

    //- Filtros y tabla
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12 style='margin-top: 5px;')
        v-layout(wrap style='justify-content: space-between; padding: 0 8px;')
          v-flex(xs3)
            v-text-field(v-model='search' label='Buscar (nombre / cliente)' clearable)
          v-flex(xs2 style='padding-left:12px;')
            v-select(:items='filtrosEstatus' v-model='filtroEstatus' label='Estatus' clearable)
          v-flex(xs2 style='padding-left:12px;display:flex;align-items:center;')
            v-menu(ref='menu' v-model='menuFecha' :close-on-content-click='false' transition='scale-transition' offset-y max-width='290px')
              template(v-slot:activator='{ on, attrs }')
                v-text-field(v-model='filtroFecha' label='Fecha' clearable readonly v-bind='attrs' v-on='on')
              v-date-picker(v-model='filtroFecha' no-title @input='menuFecha = false')
          v-flex(xs1 style='display:flex;align-items:center;padding-left:8px;')
            v-btn(icon @click='limpiarFiltros' title='Limpiar filtros')
              v-icon(color='grey') clear
        v-card(color='' style="border-radius: 0px 0px 20px 20px;background-color:black;")
          v-card-title(style="padding: 7px;").justify-center
            span.white--text Lista de Pagos Zelle
        v-data-table.elevation-1(
          :headers='headers'
          :items='resultadosFiltrados'
          :search='search'
          :loading='loading'
          :pagination.sync='pagination'
          style='margin-top: 5px;'
        )
          template(slot='items' slot-scope='props')
            td {{ transform(props.item.fecha) }}
            td {{ props.item.nombre }}
            td ${{ props.item.monto ? props.item.monto.toFixed(2) : '0.00' }}
            td {{ props.item.referencia || '-' }}
            td
              v-chip(:color='colorEstatus(props.item.estatus)' text-color='white' small)
                | {{ props.item.estatus }}
            td {{ props.item.nombre_cliente || '-' }}
            td {{ props.item.ven_des || '-' }}
            td
              v-btn(icon @click='verDetalle(props.item)')
                v-icon(color='#d50d10') visibility
</template>

<script>
import Api from "@/services/api";
import moment from "moment";

export default {
  name: "ZellePagos",
  data() {
    return {
      loading: false,
      loadingProcesar: false,
      loadingRechazar: false,
      loadingReset: false,
      loadingAsignar: false,
      resultados: [],
      search: "",
      filtroEstatus: null,
      filtroFecha: null,
      menuFecha: false,
      dialogDetalle: false,
      pagoSeleccionado: null,
      dialogAsignar: false,
      busquedaCliente: "",
      clientesBusqueda: [],
      clienteSeleccionado: null,
      referenciaManual: "",
      imagenManual: null,
      imagenManualPreview: null,
      loadingClientes: false,
      busquedaTimer: null,
      pagination: { sortBy: 'fecha', descending: true, rowsPerPage: 25 },
      filtrosEstatus: ["pendiente", "Asignado", "Procesado", "Rechazado"],
      headers: [
        { text: "Fecha", value: "fecha" },
        { text: "Nombre", value: "nombre" },
        { text: "Monto", value: "monto" },
        { text: "Referencia", value: "referencia" },
        { text: "Estatus", value: "estatus" },
        { text: "Cliente", value: "nombre_cliente" },
        { text: "Vendedor", value: "ven_des" },
        { text: "Acciones", sortable: false },
      ],
    };
  },
  computed: {
    resultadosFiltrados() {
      let lista = this.resultados;
      if (this.filtroEstatus) {
        lista = lista.filter((p) => p.estatus === this.filtroEstatus);
      }
      if (this.filtroFecha) {
        lista = lista.filter((p) =>
          moment(p.fecha).isSame(this.filtroFecha, "day")
        );
      }
      return lista;
    },
  },
  mounted() {
    this.cargarPagos();
  },
  methods: {
    async cargarPagos() {
      this.loading = true;
      try {
        const res = await Api().get("zellepago");
        this.resultados = res.data;
      } catch (e) {
        console.error("Error cargando pagos Zelle:", e);
      } finally {
        this.loading = false;
      }
    },
    verDetalle(pago) {
      this.pagoSeleccionado = { ...pago };
      this.dialogDetalle = true;
    },
    async procesarPago(id) {
      if (!confirm("¿Marcar este pago como Procesado?")) return;
      this.loadingProcesar = true;
      try {
        await Api().put(`zellepago/process/${id}`);
        this.dialogDetalle = false;
        await this.cargarPagos();
      } catch (e) {
        console.error("Error procesando pago:", e);
      } finally {
        this.loadingProcesar = false;
      }
    },
    async rechazarPago(id) {
      if (!confirm("¿Rechazar este pago? Volverá a estado Pendiente y se borrarán los datos de asignación.")) return;
      this.loadingRechazar = true;
      try {
        await Api().put(`zellepago/reset/${id}`);
        this.dialogDetalle = false;
        await this.cargarPagos();
      } catch (e) {
        console.error("Error rechazando pago:", e);
      } finally {
        this.loadingRechazar = false;
      }
    },
    async resetPago(id) {
      if (!confirm("¿Regresar este pago a estado Pendiente? Se borrarán los datos de asignación.")) return;
      this.loadingReset = true;
      try {
        await Api().put(`zellepago/reset/${id}`);
        this.dialogDetalle = false;
        await this.cargarPagos();
      } catch (e) {
        console.error("Error reseteando pago:", e);
      } finally {
        this.loadingReset = false;
      }
    },
    abrirAsignacion(pago) {
      this.pagoSeleccionado = pago;
      this.busquedaCliente = "";
      this.clientesBusqueda = [];
      this.clienteSeleccionado = null;
      this.referenciaManual = pago.referencia || "";
      this.imagenManual = null;
      this.imagenManualPreview = null;
      this.dialogAsignar = true;
    },
    onImagenSeleccionada(e) {
      const file = e.target.files[0];
      if (!file) return;
      this.imagenManual = file;
      this.imagenManualPreview = URL.createObjectURL(file);
    },
    buscarClientes() {
      clearTimeout(this.busquedaTimer);
      this.clienteSeleccionado = null;
      if (!this.busquedaCliente || this.busquedaCliente.length < 2) {
        this.clientesBusqueda = [];
        return;
      }
      this.loadingClientes = true;
      this.busquedaTimer = setTimeout(async () => {
        try {
          const res = await Api().get(`zellepago/clientes-search?q=${encodeURIComponent(this.busquedaCliente)}`);
          this.clientesBusqueda = res.data || [];
        } catch (e) {
          console.error("Error buscando clientes:", e);
        } finally {
          this.loadingClientes = false;
        }
      }, 350);
    },
    seleccionarCliente(cli) {
      this.clienteSeleccionado = cli;
      this.busquedaCliente = cli.cli_des;
      this.clientesBusqueda = [];
    },
    async confirmarAsignacion() {
      if (!this.clienteSeleccionado || !this.pagoSeleccionado) return;
      this.loadingAsignar = true;
      try {
        const formData = new FormData();
        formData.append('clienteId', this.clienteSeleccionado.co_cli);
        formData.append('clienteName', this.clienteSeleccionado.cli_des);
        formData.append('referencia', this.referenciaManual);
        formData.append('vendedor', 'admin');
        formData.append('venDes', 'Administrador');
        if (this.imagenManual) {
          formData.append('comprobante', this.imagenManual);
        }
        await Api().post(`zellepago/assign/${this.pagoSeleccionado._id}`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        this.dialogAsignar = false;
        this.dialogDetalle = false;
        await this.cargarPagos();
      } catch (e) {
        console.error("Error asignando pago:", e);
      } finally {
        this.loadingAsignar = false;
      }
    },
    colorEstatus(estatus) {
      if (estatus === "pendiente") return "red";
      if (estatus === "Asignado") return "orange";
      if (estatus === "Procesado") return "green";
      if (estatus === "Rechazado") return "grey darken-1";
      return "grey";
    },
    transform(fecha) {
      if (!fecha) return "-";
      return moment(fecha).format("DD/MM/YYYY HH:mm");
    },
    limpiarFiltros() {
      this.filtroEstatus = null;
      this.filtroFecha = null;
      this.search = "";
    },
  },
};
</script>
